var render = function render(){
  var _vm$armadaDetail, _vm$armadaDetail$owne, _vm$armadaDetail2, _vm$armadaDetail2$own, _vm$armadaDetail3, _vm$armadaDetail3$own, _vm$armadaDetail4, _vm$armadaDetail4$own, _vm$armadaDetail5, _vm$armadaDetail5$own;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-start shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info Armada")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("ID")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.armadaDetail.id))])]), _c('div', {
    staticClass: "mb-6 flex gap-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Truck")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.armadaDetail.vehicle_name))])]), _c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Tahun Kendaraan")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.armadaDetail.vehicle_production_year))])])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Plat Armada")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.armadaDetail.vehicle_plat_id))])]), _c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Tipe Aset")]), _c('div', {
    staticClass: "mb-6 flex gap-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Jenis Aset")]), _c('p', {
    staticClass: "text-neutral-500 capitalize"
  }, [_vm._v(_vm._s(_vm.armadaDetail.ownership_type))])]), _vm.armadaDetail.ownership_type === 'partner' ? _c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kepemilikan")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s((_vm$armadaDetail = _vm.armadaDetail) === null || _vm$armadaDetail === void 0 ? void 0 : (_vm$armadaDetail$owne = _vm$armadaDetail.ownership_assigned) === null || _vm$armadaDetail$owne === void 0 ? void 0 : _vm$armadaDetail$owne.name))])]) : _vm._e()]), _vm.armadaDetail.ownership_type === 'partner' ? _c('div', {
    staticClass: "shadow-border p-6 bg-neutral-200 rounded-md"
  }, [_c('div', {
    staticClass: "flex items-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s((_vm$armadaDetail2 = _vm.armadaDetail) === null || _vm$armadaDetail2 === void 0 ? void 0 : (_vm$armadaDetail2$own = _vm$armadaDetail2.ownership_assigned) === null || _vm$armadaDetail2$own === void 0 ? void 0 : _vm$armadaDetail2$own.name))])]), _c('div', {}, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("No. Handphone")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s((_vm$armadaDetail3 = _vm.armadaDetail) === null || _vm$armadaDetail3 === void 0 ? void 0 : (_vm$armadaDetail3$own = _vm$armadaDetail3.ownership_assigned) === null || _vm$armadaDetail3$own === void 0 ? void 0 : _vm$armadaDetail3$own.phone_number))])])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Alamat")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s((_vm$armadaDetail4 = _vm.armadaDetail) === null || _vm$armadaDetail4 === void 0 ? void 0 : (_vm$armadaDetail4$own = _vm$armadaDetail4.ownership_assigned) === null || _vm$armadaDetail4$own === void 0 ? void 0 : _vm$armadaDetail4$own.address))])]), _c('div', {}, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Total Aset")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s((_vm$armadaDetail5 = _vm.armadaDetail) === null || _vm$armadaDetail5 === void 0 ? void 0 : (_vm$armadaDetail5$own = _vm$armadaDetail5.ownership_assigned) === null || _vm$armadaDetail5$own === void 0 ? void 0 : _vm$armadaDetail5$own.total_vehicle))])])]) : _vm._e(), _vm.armadaDetail.ownership_type === 'company' ? _c('div', {}, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Kurir")]), _vm._l(_vm.armadaDetail.driver_assigned, function (kurir) {
    return _c('div', {
      key: kurir.id,
      staticClass: "mb-1"
    }, [_c('p', {
      staticClass: "text-neutral-500"
    }, [_vm._v(_vm._s(kurir.name))])]);
  })], 2) : _vm._e()]), _c('div', {
    staticClass: "flex-1 p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Dokumen")]), _c('div', {
    staticClass: "flex gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-32"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("STNK")]), _c('div', {
    staticClass: "border p-2 w-full rounded-md"
  }, [_c('a', {
    attrs: {
      "href": _vm.armadaDetail.stnk_file_url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.armadaDetail.stnk_file_url
    }
  })])])]), _c('div', {
    staticClass: "w-32"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("BPKB")]), _c('div', {
    staticClass: "border p-2 w-full rounded-md"
  }, [_c('a', {
    attrs: {
      "href": _vm.armadaDetail.bpkb_file_url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.armadaDetail.bpkb_file_url
    }
  })])])])]), _c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Foto Kendaraan")]), _c('div', {
    staticClass: "flex gap-6 mdmax:flex-wrap"
  }, [_c('div', {
    staticClass: "border p-2 w-32 rounded-md"
  }, [_c('a', {
    attrs: {
      "href": _vm.armadaDetail.vehicle_photo_url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.armadaDetail.vehicle_photo_url
    }
  })])])])])]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end mdmax:justify-center"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Hapus",
      "type": "delete",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleDeleteModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Edit",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.edit();
      }
    }
  })], 1), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleDeleteModal,
      "id": "delete-modal"
    },
    on: {
      "close": _vm.toggleDeleteModal
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "text-cente mt-6 mb-4"
  }, [_vm._v("Apakah Anda yakin akan menghapus partner ini?")]), _c('div', {
    staticClass: "flex justify-center items-center gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.deleteItem();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleDeleteModal();
      }
    }
  })], 1)])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }